import { useEffect, useRef, useState } from 'react';

export const useMinLoadingTime = (
  loading: boolean,
  minTimeMs = 350
): boolean => {
  const [show, setShow] = useState(false);
  const startTimeRef = useRef<number | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (loading) {
      startTimeRef.current = Date.now();
      setShow(true);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      return;
    }

    const elapsed = Date.now() - (startTimeRef.current ?? Date.now());

    const remaining = Math.max(minTimeMs - elapsed, 0);

    timeoutRef.current = setTimeout(() => {
      setShow(false);
    }, remaining);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [loading, minTimeMs]);

  return show;
};
